<template>
  <b-container fluid>
    <b-button
      v-b-modal.cover-select-modal
      class="btn-block cover-print-btn"
    >
      <fa-icon icon="print" />พิมพ์ใบปะหน้า
    </b-button>
    <b-modal
      id="cover-select-modal"
      ref="coverSelectModal"
      centered
      hide-footer
      title="เลือกประเภทใบปะหน้าที่ต้องการพิมพ์"
      size="lg"
    >
      <b-container fluid>
        <div
          v-if="isLoading"
          class="loading"
        >
          <b-spinner
            type="grow"
            label="Spinning"
          />
        </div>
        <b-row>
          <!-- <b-col class="p-0">
                        <b-button size="lg" class="cover-btn distance btn-block">
                            แยกตามเส้นทาง
                        </b-button>
                    </b-col>
                    <b-col class="p-0">
                        <b-button size="lg" class="cover-btn corporation btn-block">
                            แยกตามบริษัท
                        </b-button>
          </b-col>-->
          <b-col>
            <b-form-radio-group v-model="typeSelected">
              <b-row>
                <b-col :class="{'form-select': true, select: typeSelected === 'direction' }">
                  <b-row class="text-center">
                    <b-col>
                      <b-form-radio value="direction">
                        เลือกตามเขตเส้นทาง
                      </b-form-radio>
                    </b-col>
                  </b-row>
                  <b-row class="text-center">
                    <b-col>
                      <b-form-select
                        v-model="directionSelected"
                        text-field="direction"
                        value-field="id"
                        :options="directions"
                        size="sm"
                      >
                        <option :value="null">
                          เลือกเส้นทาง
                        </option>
                      </b-form-select>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col :class="{'form-select': true, select: typeSelected === 'corporation' }">
                  <b-row class="text-center">
                    <b-col>
                      <b-form-radio value="corporation">
                        เลือกตามบริษัท
                      </b-form-radio>
                    </b-col>
                  </b-row>
                  <b-row class="text-center">
                    <b-col>
                      <b-form-select
                        v-model="corporationSelected"
                        :options="platforms.filter((platform => platform.is_filter))"
                        text-field="en_name"
                        value-field="id"
                        size="sm"
                      >
                        <option :value="null">
                          เลือกบริษัท
                        </option>
                      </b-form-select>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col :class="{'form-select': true, select: typeSelected === 'all' }">
                  <b-form-radio value="all">
                    เลือกทั้งหมด
                  </b-form-radio>
                </b-col>
              </b-row>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            class="p-0"
            cols="12"
          >
            <b-button
              size="lg"
              class="cover-btn all btn-block"
              @click="coverPrintHandler"
            >
              พิมพ์
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </b-container>
</template>

<script>
import printJS from "print-js";
import moment from 'moment'
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CoverPageModal",
  props: {
    documentFilter: {
      required: true,
      type: Object,
    }
  },
  data() {
    return {
      corporationSelected: null,
      directionSelected: null,
      typeSelected: "direction",
      isLoading: false
    };
  },
  computed: {
    ...mapGetters({
      platforms: "Account/getPlatforms",
      directions: "Direction/getAll"
    })
  },
  methods: {
    ...mapActions({
      printCover: "Account/printCover",
      checkPermission: "Order/checkPermission"
    }),
    async coverPrintHandler() {
      let permission = await this.permission("accountant", "can_print");
      this.isLoading = true
      if (permission) {
        let url = `cover-document-print/${this.typeSelected}`;
        if (this.typeSelected === "corporation") {
          if (!this.corporationSelected) {
            this.$swal.fire("กรุณาเลือกบริษัทก่อนพิมพ์");
            this.isLoading = false
            return;
          } else {
            url += `?id=${this.corporationSelected}`;
            if (this.documentFilter.dateOne) {
              
              url += `&date=${moment(this.documentFilter.dateOne).format("YYYY-MM-DD")}`
            }
          }
        } else if (this.typeSelected === "direction") {
          if (!this.directionSelected) {
            this.$swal.fire("กรุณาเลือกเส้นทางก่อนพิมพ์");
            this.isLoading = false
            return;
          } else {
            url += `?id=${this.directionSelected}`;
            if (this.documentFilter.dateOne) {
              url += `&date=${moment(this.documentFilter.dateOne).format("YYYY-MM-DD")}`
            }
          }
        } else {
          if (this.documentFilter.dateOne) {
            url += `?date=${moment(this.documentFilter.dateOne).format("YYYY-MM-DD")}`
          }
        }

        

        await this.$nextTick().then(async () => {
          await this.$nextTick().then(async () => {
            printJS({
              printable: `${process.env.VUE_APP_IP}${url}`,
              type: "pdf",
              showModal: true
            });

            this.$nextTick().then(() => {
              this.isLoading = false
              this.$refs.coverSelectModal.hide();
            });
          });
        });
      }
    },
    async permission(type, mod) {
      let permission = await this.checkPermission({
        type: type,
        mod: mod
      });

      if (!permission) {
        this.$notify({
          group: "alert",
          title: "มีข้อผิดพลาดบางอย่าง",
          text: permission,
          position: "bottom right",
          type: "error"
        });
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.cover-print-btn {
  background-color: #fb822b;
  border: none;
}
.cover-btn {
  border-radius: 0;
  border: none;
  &.distance {
    background: #fb822b;
    &:hover {
      background: #944a1c;
    }
  }
  &.corporation {
    background: #2e83d9;
    &:hover {
      background: #1f4a83;
    }
  }
  &.all {
    background: indianred;
    &:hover {
      background: #753737;
    }
  }
}

.form-select {
  // height: 15rem;
  border: 1px solid black;
  padding: 1rem;
  margin: 1rem;
  text-align: center;
  // opacity: 0.1;
  &.select {
    background: #fb822b;
    color: white;
  }
}
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
}
</style>
